<template>
    <div class="header" :style="{ background: `linear-gradient(to right,  ${initData.mainColor})` }">
        <!-- <div class="header_left">
            <svg @click="goBack" t="1662043331046" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="5641" width="22" height="22">
                <path
                    d="M384 512L731.733333 202.666667c17.066667-14.933333 19.2-42.666667 4.266667-59.733334-14.933333-17.066667-42.666667-19.2-59.733333-4.266666l-384 341.333333c-10.666667 8.533333-14.933333 19.2-14.933334 32s4.266667 23.466667 14.933334 32l384 341.333333c8.533333 6.4 19.2 10.666667 27.733333 10.666667 12.8 0 23.466667-4.266667 32-14.933333 14.933333-17.066667 14.933333-44.8-4.266667-59.733334L384 512z"
                    p-id="5642" fill="#ffffff"></path>
            </svg>
        </div> -->
        <div class="logo">
            <img :src="customer.adminFace || initData.robotIcon || avator" />
            <div>
                <p class="company">{{ initData.titleDesc }}</p>
            </div>
            <div v-if="agentTyping" class="typing">{{ $t('customerInputIng') }}</div>
        </div>
        <!-- <div class="header_right">
            <svg @click="close" t="1662043269002" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="4632" width="22" height="22">
                <path
                    d="M453.44 512L161.472 220.032a41.408 41.408 0 0 1 58.56-58.56L512 453.44 803.968 161.472a41.408 41.408 0 0 1 58.56 58.56L570.56 512l291.968 291.968a41.408 41.408 0 0 1-58.56 58.56L512 570.56 220.032 862.528a41.408 41.408 0 0 1-58.56-58.56L453.44 512z"
                    fill="#ffffff" p-id="4633"></path>
            </svg>
        </div> -->
    </div>
</template>

<script>
import language from '../../store/index';
import chatApi from "../methods";
import urlParams from "../../api/urlParams";
import avator from "../../../static/image/custom.png";

export default {
    name: "Header",
    data() {
        return {
            title: '1234',
            isIframe: false,
            avator: avator,
        }
    },
    watch: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        initData() {
            return this.$store.state.initData;
        },
        customer() {
            return this.$store.state.customer;
        },
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        initData() {
            return this.$store.state.initData;
        },
        customer() {
            return this.$store.state.customer;
        },
        agentTyping() {
            return this.$store.state.agentTyping;
        },
    },
    mounted() {
        if (urlParams("from") === "iframe") {
            this.isIframe = true;
        }
    },
    methods: {
        goBack() {
            window.history.go(-1);
        },
        close() {
            if (urlParams("inviteEvaluate")) {
                // 先提示评价
                chatApi.inviteEvaluate(() => {
                    // chatApi.closeChatSession();
                    if (this.isIframe) {
                        window.parent.postMessage({ hidden: true }, "*");
                        window.location.reload();
                    } else {
                        //直接关闭窗口
                        if (urlParams("close")) {
                            window.location.href = 'about:blank'
                            window.close();
                        }
                    }
                });
                return
            }
            if (this.isIframe) {
                window.parent.postMessage({ hidden: true }, "*");
                window.location.reload();
            } else {
                //直接关闭窗口
                this.goBack()
            }
        }
    }
}
</script>
<style scoped>
.header {
    height: 50px;
    padding: 12px 9px;
    display: flex;
    font-size: 16px;
    font-weight: 500;
    justify-content: space-around;
}

.header_left {
    flex: 1;
    text-align: left;
}

.header_left span {
    display: inline-block;
}

.close {
    margin: 0 4px;
}

.header_center {
    flex: 1;
    line-height: 23px;
    color: white;
}

.title {
    margin: 0 9px;
    letter-spacing: 2px;
}

.close::before {
    content: "\2716";
}

.header_right {
    flex: 1;
    text-align: right;
}



.logo {
    flex: 7;
    text-align: left;
    overflow: hidden;
    display: flex;
}

.logo img {
    width: 36px;
    height: 36px;
    margin: 13px 10px 13px 20px;
    border-radius: 50%;
}

.logo>div {
    font-size: 0;
    color: #ffffff;
    vertical-align: top;
    margin: 13px 0;
    flex: 1;
}
.logo .company {
  font-size: 14px;
  line-height: 34px;
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/h5/header.vue